import BaseAPI from "./BaseAPI";

class CommonAPI extends BaseAPI {
  constructor() {
    super();
  }

  // Filter API
  async filterAPI(pageName, pageType) {
    const req = {
      url: "filter",
      method: "POST",
      data: { pageName: pageName, ...(pageType && { pageType }) },
    };
    return await this.makeRequest(req);
  }

  // Blacklisted API
  async blacklistedAPI(pageName) {
    const queryParams = new URLSearchParams(window.location.search);
    const req = {
      url: `blacklist/blacklist_user?pageName=${pageName}&${queryParams.toString()}`,
      method: "GET",
      data: { pageName },
    };

    return await this.makeRequest(req);
  }

  async getUserPermissionAPI() {
    const req = {
      url: "user/getUserPermission",
      method: "GET",
    };
    return await this.makeRequest(req);
  }

  async fetchResourceUrlAPI(entityID, type = "agreement") {
    const req = {
      url: `doc/pdf-url?entityID=${entityID}&type=${type}`,
      method: "GET",
    };
    return await this.makeRequest(req);
  }

  // PII Reveal API — sends full audit context required by the backend
  getPIIValue = async ({ customer_id, lead_id, crm_user_id, crm_username, page_name, module, type }) => {
    const req = {
      url: `customer/pii`,
      method: "POST",
      data: {
        ...(customer_id && {customer_id: parseInt(customer_id)}),
        ...(lead_id && {lead_id: parseInt(lead_id)}),
        crm_user_id,
        crm_username,
        page_name,
        module,
        type,
      },
    };
    return await this.makeRequest(req, false);
  }
}

export default CommonAPI;
